export enum BillMode {
    showBill,
    showSplit,
    showCustom,
  }